import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { COLOR_GREY50, COLOR_GREY_11, COLOR_WHITE } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";
import PrimaryButton from "../PrimaryButton";

export const StyledModal = styled(Dialog)`
  &.MuiDialog-root {
    .MuiDialog-paper {
      border-radius: 1rem;
    }
  }
`;

export const StyledBox = styled(Box)`
  ${flex({ fd: "column" })};
  min-width: 560px;
  padding: 1.5rem 1rem;
  row-gap: 1.5rem;
  background-color: ${COLOR_GREY50};
`;

export const StyledTitle = styled(Typography)`
  text-align: left;
  font-weight: 700;
`;

export const StyledButtonsPopup = styled(Box)`
  ${flex({ jc: "flex-end", ai: "center" })};
  column-gap: 1rem;
`;

export const StyledCancelButton = styled(PrimaryButton)`
  &.MuiButton-root {
    color: ${COLOR_GREY_11};
    font-weight: 700;
    font-size: 1rem;
    border: 1px solid #d4d4d4;

    &.rounded {
      border-radius: 0.5rem;
    }
  }
`;

export const StyledDeleteButton = styled(PrimaryButton, {
  shouldForwardProp: (props) => props !== "buttonColor",
})<{ buttonColor: string }>`
  &.MuiButton-root {
    color: ${COLOR_WHITE};
    background-color: ${(props) => props.buttonColor};
    font-weight: 700;
    font-size: 1rem;
    border-radius: 0.5rem;

    &.rounded {
      border-radius: 0.5rem;
    }
  }
`;
